const translation = {
  category: {
    bundles: 'Paquetes',
    all: 'Todo',
    extensions: 'Extensiones',
    tools: 'Herramientas',
    agents: 'Estrategias de los agentes',
    models: 'Modelos',
  },
  categorySingle: {
    bundle: 'Haz',
    extension: 'Extensión',
    tool: 'Herramienta',
    model: 'Modelo',
    agent: 'Estrategia del agente',
  },
  list: {
    source: {
      marketplace: 'Instalar desde Marketplace',
      github: 'Instalar desde GitHub',
      local: 'Instalar desde el archivo de paquete local',
    },
    noInstalled: 'No hay plugins instalados',
    notFound: 'No se han encontrado plugins',
  },
  source: {
    marketplace: 'Mercado',
    local: 'Archivo de paquete local',
    github: 'GitHub (en inglés)',
  },
  detailPanel: {
    categoryTip: {
      local: 'Plugin Local',
      marketplace: 'Instalado desde Marketplace',
      github: 'Instalado desde Github',
      debugging: 'Complemento de depuración',
    },
    operation: {
      viewDetail: 'Ver Detalle',
      detail: 'Detalles',
      checkUpdate: 'Comprobar actualización',
      install: 'Instalar',
      remove: 'Eliminar',
      info: 'Información del plugin',
      update: 'Actualizar',
    },
    toolSelector: {
      toolLabel: 'Herramienta',
      paramsTip1: 'Controla los parámetros de inferencia de LLM.',
      settings: 'CONFIGURACIÓN DEL USUARIO',
      unsupportedContent2: 'Haga clic para cambiar de versión.',
      descriptionPlaceholder: 'Breve descripción del propósito de la herramienta, por ejemplo, obtener la temperatura para una ubicación específica.',
      empty: 'Haga clic en el botón \'+\' para agregar herramientas. Puede agregar varias herramientas.',
      paramsTip2: 'Cuando \'Automático\' está desactivado, se utiliza el valor predeterminado.',
      uninstalledTitle: 'Herramienta no instalada',
      descriptionLabel: 'Descripción de la herramienta',
      unsupportedContent: 'La versión del plugin instalado no proporciona esta acción.',
      auto: 'Automático',
      title: 'Agregar herramienta',
      placeholder: 'Seleccione una herramienta...',
      uninstalledContent: 'Este plugin se instala desde el repositorio local/GitHub. Úselo después de la instalación.',
      unsupportedTitle: 'Acción no admitida',
      params: 'CONFIGURACIÓN DE RAZONAMIENTO',
      uninstalledLink: 'Administrar en Plugins',
      toolSetting: 'Configuraciones de la herramienta',
    },
    endpointDeleteContent: '¿Te gustaría eliminar {{nombre}}?',
    endpointDisableTip: 'Deshabilitar punto de conexión',
    endpointDeleteTip: 'Eliminar punto de conexión',
    strategyNum: '{{num}} {{estrategia}} INCLUIDO',
    disabled: 'Deshabilitado',
    serviceOk: 'Servicio OK',
    endpointDisableContent: '¿Te gustaría desactivar {{name}}?',
    switchVersion: 'Versión del interruptor',
    endpointsTip: 'Este complemento proporciona funcionalidades específicas a través de puntos finales, y puede configurar varios conjuntos de puntos finales para el espacio de trabajo actual.',
    configureModel: 'Configurar modelo',
    actionNum: '{{num}} {{acción}} INCLUIDO',
    configureTool: 'Herramienta de configuración',
    endpointModalDesc: 'Una vez configurado, se pueden utilizar las funciones proporcionadas por el complemento a través de los puntos finales de la API.',
    modelNum: '{{num}} MODELOS INCLUIDOS',
    endpoints: 'Extremos',
    endpointModalTitle: 'Punto de conexión de configuración',
    endpointsDocLink: 'Ver el documento',
    endpointsEmpty: 'Haga clic en el botón \'+\' para agregar un punto de conexión',
    configureApp: 'Configurar la aplicación',
  },
  debugInfo: {
    title: 'Depuración',
    viewDocs: 'Ver documentos',
  },
  privilege: {
    everyone: 'Todos',
    title: 'Preferencias del plugin',
    whoCanDebug: '¿Quién puede depurar plugins?',
    admins: 'Administradores',
    whoCanInstall: '¿Quién puede instalar y administrar complementos?',
    noone: 'Nadie',
  },
  pluginInfoModal: {
    repository: 'Depósito',
    title: 'Información del plugin',
    packageName: 'Paquete',
    release: 'Lanzamiento',
  },
  action: {
    checkForUpdates: 'Buscar actualizaciones',
    deleteContentLeft: '¿Le gustaría eliminar',
    deleteContentRight: '¿Complemento?',
    usedInApps: 'Este plugin se está utilizando en las aplicaciones {{num}}.',
    delete: 'Eliminar plugin',
    pluginInfo: 'Información del plugin',
  },
  installModal: {
    labels: {
      repository: 'Depósito',
      version: 'Versión',
      package: 'Paquete',
    },
    installPlugin: 'Instalar plugin',
    close: 'Cerrar',
    uploadingPackage: 'Subiendo {{packageName}}...',
    installComplete: 'Instalación completa',
    installFailed: 'Error de instalación',
    fromTrustSource: 'Por favor, asegúrate de que sólo instalas plugins de una <trustSource>fuente de confianza</trustSource>.',
    installedSuccessfullyDesc: 'El plugin se ha instalado correctamente.',
    back: 'Atrás',
    installFailedDesc: 'El plugin ha fallado en la instalación.',
    installing: 'Instalar...',
    next: 'Próximo',
    readyToInstallPackages: 'A punto de instalar los siguientes plugins {{num}}',
    cancel: 'Cancelar',
    uploadFailed: 'Error de carga',
    install: 'Instalar',
    pluginLoadError: 'Error de carga del plugin',
    pluginLoadErrorDesc: 'Este plugin no se instalará',
    readyToInstall: 'A punto de instalar el siguiente plugin',
    dropPluginToInstall: 'Suelte el paquete del complemento aquí para instalarlo',
    readyToInstallPackage: 'A punto de instalar el siguiente plugin',
    installedSuccessfully: 'Instalación exitosa',
  },
  installFromGitHub: {
    uploadFailed: 'Error de carga',
    updatePlugin: 'Actualizar plugin desde GitHub',
    selectPackagePlaceholder: 'Por favor, seleccione un paquete',
    installedSuccessfully: 'Instalación exitosa',
    installNote: 'Por favor, asegúrate de que sólo instalas plugins de una fuente de confianza.',
    gitHubRepo: 'Repositorio de GitHub',
    selectPackage: 'Seleccionar paquete',
    selectVersion: 'Seleccionar versión',
    selectVersionPlaceholder: 'Por favor, seleccione una versión',
    installPlugin: 'Instalar plugin desde GitHub',
    installFailed: 'Error de instalación',
  },
  upgrade: {
    upgrading: 'Instalar...',
    close: 'Cerrar',
    description: 'A punto de instalar el siguiente plugin',
    upgrade: 'Instalar',
    title: 'Instalar plugin',
    successfulTitle: 'Instalación correcta',
    usedInApps: 'Usado en aplicaciones {{num}}',
  },
  error: {
    fetchReleasesError: 'No se pueden recuperar las versiones. Por favor, inténtelo de nuevo más tarde.',
    noReleasesFound: 'No se han encontrado versiones. Compruebe el repositorio de GitHub o la URL de entrada.',
    inValidGitHubUrl: 'URL de GitHub no válida. Introduzca una URL válida en el formato: https://github.com/owner/repo',
  },
  marketplace: {
    sortOption: {
      recentlyUpdated: 'Actualizado recientemente',
      newlyReleased: 'Recién estrenado',
      firstReleased: 'Lanzado por primera vez',
      mostPopular: 'Lo más popular',
    },
    empower: 'Potencie su desarrollo de IA',
    moreFrom: 'Más de Marketplace',
    viewMore: 'Ver más',
    sortBy: 'Ciudad negra',
    noPluginFound: 'No se ha encontrado ningún plugin',
    pluginsResult: '{{num}} resultados',
    discover: 'Descubrir',
    and: 'y',
    difyMarketplace: 'Mercado de Dify',
    verifiedTip: 'Verificado por Dify',
    partnerTip: 'Verificado por un socio de Dify',
  },
  task: {
    installing: 'Instalando plugins {{installingLength}}, 0 hecho.',
    clearAll: 'Borrar todo',
    installingWithSuccess: 'Instalando plugins {{installingLength}}, {{successLength}} éxito.',
    installedError: 'Los complementos {{errorLength}} no se pudieron instalar',
    installError: 'Los complementos {{errorLength}} no se pudieron instalar, haga clic para ver',
    installingWithError: 'Instalando plugins {{installingLength}}, {{successLength}} éxito, {{errorLength}} fallido',
  },
  fromMarketplace: 'De Marketplace',
  endpointsEnabled: '{{num}} conjuntos de puntos finales habilitados',
  from: 'De',
  installAction: 'Instalar',
  install: '{{num}} instalaciones',
  allCategories: 'Todas las categorías',
  searchCategories: 'Categorías de búsqueda',
  installFrom: 'INSTALAR DESDE',
  search: 'Buscar',
  searchInMarketplace: 'Buscar en Marketplace',
  searchTools: 'Herramientas de búsqueda...',
  findMoreInMarketplace: 'Más información en Marketplace',
  installPlugin: 'Instalar plugin',
  searchPlugins: 'Plugins de búsqueda',
  metadata: {
    title: 'Complementos',
  },
  difyVersionNotCompatible: 'La versión actual de Dify no es compatible con este plugin, por favor actualiza a la versión mínima requerida: {{minimalDifyVersion}}',
  requestAPlugin: 'Solicitar un plugin',
  publishPlugins: 'Publicar plugins',
}

export default translation
